<template>
  <div
    v-if="receiptHasNotifications"
    class="text-center"
  >
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      open-on-hover
    >
      <template #activator="{on, attrs}">
        <v-btn
          color="indigo"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            :content="receiptNotificationsCount"
            color="info"
            light
            overlap
          >
            <v-icon color="info">
              mdi-bell-ring
            </v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card>
        <v-simple-table
          class=""
          dense
        >
          <thead>
            <tr>
              <th class="text-center text-no-wrap">
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.User') }}
              </th>

              <th class="text-center text-no-wrap">
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.Email') }}
              </th>

              <th
                class="text-center text-no-wrap"
              >
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.CreatedAt') }}
              </th>

              <th
                class="text-center text-no-wrap"
              >
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.DeliveredAt') }}
              </th>

              <th
                class="text-center text-no-wrap"
              >
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.ReadAt') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(item, itemIdx) in receiptNotifications"
              :key="`receipt-${item.ReceiptId}-notification-${item.Id}-${itemIdx}`"
            >
              <td class="text-caption text-center text-no-wrap">
                <user-chip
                  v-if="item.UserId > 0"
                  :color="item.UserColor"
                  :full-name="item.User"
                  :short-name="item.UserShortName"
                />
              </td>

              <td class="text-caption text-no-wrap">
                {{ item.Email }}
              </td>

              <td
                class="text-caption text-no-wrap text-center"
              >
                {{ item.CreatedAt }}
              </td>

              <td
                class="text-center"
              >
                <v-tooltip
                  v-if="item.DeliveredAt"
                  color="success"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="success"
                      v-on="on"
                    >
                      mdi-email-check
                    </v-icon>
                  </template>

                  {{ item.DeliveredAt }}
                </v-tooltip>

                <v-tooltip
                  v-if="item.BouncedAt"
                  color="error"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="error"
                      v-on="on"
                    >
                      mdi-email-remove
                    </v-icon>
                  </template>

                  <div style="max-width: 200px">
                    <div>{{ item.BouncedAt }}</div>
                    <div class="text-caption mt-2">
                      {{ item.BounceMessage }}
                    </div>
                  </div>
                </v-tooltip>
              </td>

              <td
                class="text-center"
              >
                <v-tooltip
                  v-if="item.ReadAt"
                  color="teal"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="teal"
                      v-on="on"
                    >
                      mdi-email-newsletter
                    </v-icon>
                  </template>

                  {{ item.ReadAt }}
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import {getContrastColor} from '@/lib/color/index.js'
import UserChip from '@/components/common/UserChip.vue'

export default {
  name      : 'ReceiptNotifyDetails',
  components: {UserChip},
  directives: {},
  mixins    : [],
  props     : {
    receipt: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      menu: false
    }
  },
  computed: {
    receiptNotifications() {
      const receiptNotifications = this.receipt?.NotifyTo || []
      return receiptNotifications.filter(notification => notification.ReceiptId === this.receipt?.Id)
    },

    receiptNotificationsCount() {
      return this.receiptNotifications.length
    },

    receiptHasNotifications() {
      return this.receiptNotificationsCount > 0
    },


    receiptHasCreatedNotifications() {
      return this.receiptNotifications.some(notification => !!notification.CreatedAt)
    },
    receiptHasDeliveredNotifications() {
      return this.receiptNotifications.some(notification => !!notification.DeliveredAt)
    },
    receiptHasReadNotifications() {
      return this.receiptNotifications.some(notification => !!notification.ReadAt)
    },
    receiptHasBouncedNotifications() {
      return this.receiptNotifications.some(notification => !!notification.BouncedAt)
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getContrastColor
  }
}
</script>

<style scoped>

</style>
